'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCopilot } from './context.js';
/**
 * A total `Record` over the status union: when the vocabulary grows, `tsc`
 * names this map. `unknown` reads "Unconfirmed", the word the turn-action rows
 * use for the same outcome (COP-138).
 */
const STATUS_LABEL = {
    started: 'Started',
    progress: 'In progress',
    done: 'Finished',
    failed: 'Failed',
    unknown: 'Unconfirmed',
};
function stateLine(state) {
    if (state === 'narrating')
        return 'Getting the result…';
    if (state === 'started' || state === 'progress')
        return 'Waiting for result';
    return null;
}
export function JobCard({ job }) {
    const { jobStates } = useCopilot();
    const live = jobStates.get(job.toolCallId);
    const status = live?.status ?? job.status;
    // A `done` job's last progress line describes a step that is over: the
    // finished card shows "Finished" only (M44 gate O1).
    const lastProgress = live ? live.progress : job.progress;
    const progress = status === 'done' ? undefined : lastProgress;
    const state = live?.narrating ? 'narrating' : status;
    const line = stateLine(state);
    return (_jsxs("div", { className: "copilot-job-card", "data-state": state, "data-job-id": job.jobId, children: [_jsxs("div", { className: "copilot-job-card-header", children: [_jsx("span", { className: "copilot-job-card-tool", "data-tool-name": job.toolName, children: job.toolName }), _jsx("span", { className: "copilot-job-card-status", children: STATUS_LABEL[status] })] }), progress && _jsx("p", { className: "copilot-job-card-progress", children: progress }), line && (_jsx("div", { className: "copilot-job-card-line", role: "status", children: line }))] }));
}
//# sourceMappingURL=job-card.js.map